import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import WebAssetIcon from "@mui/icons-material/WebAsset";
import PentagonIcon from "@mui/icons-material/Pentagon";
import PermDataSettingIcon from "@mui/icons-material/PermDataSetting";
import Person from "@mui/icons-material/Person";
import Person2 from "@mui/icons-material/Person2";

const menu = [
  {
    id: 1,
    title: "Master Inputs",
    role: "Master Inputs",
    icon: <PermDataSettingIcon />,
    route: "/inputs",
    children: [
      {
        id: 1,
        title: "Add Client",
        role: "Add Client",
        route: "/addClient",
        icon: <Person />,
      },
      {
        id: 1,
        title: "Add Vendor",
        role: "Add Vendor",
        route: "/addVendor",
        icon: <Person2 />,
      },
      {
        id: 3,
        title: "Add Color",
        role: "Add Color",
        route: "/addColor",
        icon: <ColorLensIcon />,
      },
      {
        id: 4,
        title: "Add Size",
        role: "Add Size",
        route: "/addSize",
        icon: <FullscreenExitIcon />,
      },

      {
        id: 6,
        title: "Add Category",
        role: "Add Category",
        route: "/addCategory",
        icon: <AccountTreeIcon />,
      },
      {
        id: 5,
        title: "Add Article",
        role: "Add Article",
        route: "/addArticle",
        icon: <WebAssetIcon />,
      },
    ],
  },
];
export default menu;
